<div
  *ngIf="loadingSignOff$ | async; else loadedContent"
  class="formgrid p-fluid flex align-items-center justify-content-center py-8"
>
  <p-progressSpinner></p-progressSpinner>
</div>
<ng-template #loadedContent>
  <p-table
    #signedOffIssuesTable
    responsiveLayout="scroll"
    scrollDirection="both"
    [scrollable]="true"
    [responsive]="true"
    [tableStyle]="{ 'min-width': '50rem' }"
    [value]="signedOffData"
    [rowHover]="true"
    [lazy]="true"
    [paginator]="true"
    [rows]="5"
    (onLazyLoad)="loadSignedOffIssues($event)"
    [totalRecords]="totalSignedOffRecords"
    scrollHeight="60vh"
    selectionMode="single"
    styleClass="app-table p-datatable-sm lg:p-datatable-md"
    [globalFilterFields]="[
      'vehicle_reference',
      'description',
      'fine_amount',
      'signoff_type',
      'date_signed_off'
    ]"
  >
    <ng-template pTemplate="caption">
      <div
        class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3 py-2"
      >
        <div class="flex align-items-center gap-2">
          <span class="text-800 font-medium">Signed off history</span>
        </div>

        <div class="w-full md:w-auto">
          <span class="p-input-icon-left p-input-icon-right w-full">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              class="w-full md:w-20rem"
              [value]="signOffSearch"
              (input)="filterSignOffGlobal($event)"
              placeholder="Search keyword"
            />
            <i
              *ngIf="signOffSearch"
              class="pi pi-times"
              style="cursor:pointer"
              (click)="clearSignOffSearch()"
            ></i>
          </span>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of signedOffColumns" [pSortableColumn]="col.field">
          <div class="flex align-items-center">
            <span>{{ col.header }}</span>
            <p-columnFilter
              type="text"
              [field]="col.field"
              display="menu"
            ></p-columnFilter>
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-product>
      <tr *ngIf="product.signed_off === true">
        <td
          *ngFor="let col of signedOffColumns"
          [class.mono-cell]="
            col.field === 'fine_amount' || col.field === 'date_signed_off'
          "
        >
          <span
            *ngIf="col.field === 'signoff_type'; else plainCell"
            class="record-tag"
          >
            {{ product[col.field] }}
          </span>
          <ng-template #plainCell>
            <span>{{ product[col.field] }}</span>
          </ng-template>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5">
          <div class="flex align-items-center justify-content-center py-4">
            <span class="text-800 font-medium text-xl">
              No signed off issues
            </span>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>
